import { useEffect, useState } from 'react';
import { ExternalMTS, getTRPCClient } from './getTRPCClient';

const getMTSById = async (mtsId: number, activityTypeId: number, userActivityTypeId?: number) => {
  const client = getTRPCClient();
  return client.query('mtsById', { mtsId, activityTypeId, userActivityTypeId });
};

export const useMTSById = (mtsId: number, activityTypeId: number, userActivityTypeId?: number) => {
  const [{ mts, loading }, setMts] = useState<{ loading: boolean, mts?: ExternalMTS }>({ loading: true });

  useEffect(() => {
    void getMTSById(mtsId, activityTypeId, userActivityTypeId).then(rtnMts => {
      rtnMts ? setMts({ mts: rtnMts, loading: false }) : setMts({ loading: false });
    });
  }, []);

  return { mts, loading };
};
